// Строит auth-кадр из заголовков авторизации (authService.getAuthHeaders()):
// KC-сессия → { authorization: 'Bearer <jwt>' }, легаси → { token: '<opaque>' }.
// Бэкенд принимает оба и предпочтёт Bearer (см. bit-streaming/app/main.py).
function buildAuthFrame(authHeaders = {}) {
  const frame = { type: 'auth' };
  if (authHeaders.Authorization) frame.authorization = authHeaders.Authorization;
  else if (authHeaders.token) frame.token = authHeaders.token;
  return frame;
}

// WS-клиент протокола bit-streaming v1: ready → auth → status → PCM/события.
// Один объект — один сокет. Переподключение после обрыва — уровнем выше
// (components/streaming/resilientSession.js), здесь только протокол.
export function createStreamingSession({ wsUrl, authHeaders, onPartial, onFinal, onStatus, onPong, onError, onClose }) {
  const ws = new WebSocket(wsUrl);
  ws.binaryType = 'arraybuffer';
  ws.onmessage = (ev) => {
    const msg = JSON.parse(ev.data);
    // authHeaders может быть функцией: заголовки берутся в момент auth-кадра.
    // Переподключение идёт через минуты после старта, а access-токен Keycloak
    // живёт 300 с — снимок на момент создания сокета был бы уже протухшим.
    if (msg.type === 'ready') {
      const headers = typeof authHeaders === 'function' ? authHeaders() : authHeaders;
      ws.send(JSON.stringify(buildAuthFrame(headers)));
    }
    else if (msg.type === 'status') onStatus?.(msg);
    else if (msg.type === 'partial') onPartial?.(msg);
    else if (msg.type === 'final') onFinal?.(msg);
    else if (msg.type === 'pong') onPong?.(msg);
    else if (msg.type === 'error') onError?.(msg);
  };
  ws.onerror = (e) => onError?.({ type: 'error', code: 'ws_error', event: e });
  ws.onclose = (e) => onClose?.(e);
  return {
    sendPcm(int16) { if (ws.readyState === WebSocket.OPEN) ws.send(int16.buffer); },
    finalize() { if (ws.readyState === WebSocket.OPEN) ws.send(JSON.stringify({ type: 'finalize' })); },
    // Прикладной heartbeat: браузер не умеет WS-ping на уровне протокола, поэтому
    // мёртвое соединение замечаем сами — сервер отвечает {"type":"pong"}.
    ping() { if (ws.readyState === WebSocket.OPEN) ws.send(JSON.stringify({ type: 'ping' })); },
    // Открыт ли сокет прямо сейчас: кадр в CLOSING/CLOSED-сокет браузер молча
    // выбрасывает, а уровень выше должен оставить его в своём буфере.
    isOpen() { return ws.readyState === WebSocket.OPEN; },
    close() { ws.close(1000); },
  };
}
